import React from "react";

/**
 * Paper-grain overlay. Apply over cream-background sections to add the
 * subtle textural depth the brief calls for.
 *
 * The SVG <filter> itself is rendered once at the App root via <PaperGrainSVG />.
 * This component renders the <div> that consumes the filter.
 *
 * Usage:
 *   <section className="relative ...">
 *     ...content (z-10)...
 *     <PaperGrain />
 *   </section>
 */
export const PaperGrain = ({ opacity = 0.4, className = "" }) => (
  <div
    aria-hidden
    className={`pointer-events-none absolute inset-0 z-[1] mix-blend-multiply ${className}`}
    style={{
      filter: "url(#paperGrain)",
      backgroundColor: "#F5EBDA",
      opacity,
    }}
  />
);

export const PaperGrainSVG = () => (
  <svg
    aria-hidden
    width="0"
    height="0"
    style={{ position: "absolute", width: 0, height: 0 }}
  >
    <filter id="paperGrain">
      <feTurbulence
        type="fractalNoise"
        baseFrequency="0.85"
        numOctaves="2"
        stitchTiles="stitch"
      />
      <feColorMatrix values="0 0 0 0 0.6  0 0 0 0 0.55  0 0 0 0 0.4  0 0 0 0.06 0" />
    </filter>
  </svg>
);

export default PaperGrain;
